<div mat-dialog-content>
  <form nz-form>
    <nz-form-item>
      <nz-form-control nzHasFeedback [nzValidateStatus]="submitted && fightNameControl.errors && fightNameControl.errors.required?'error':''" nzErrorTip="You must enter a value">
        <input name="fightName" required nz-input placeholder="{{'dialog.fightSave.fightName' | translate}}" [formControl]="fightNameControl" [(ngModel)]="data.name" />
      </nz-form-control>
    </nz-form-item>
  </form>

  <div class="nostr-publish-section">
    <div class="nostr-publish-heading">
      <i nz-icon nzType="global"></i>
      <strong>Store on Nostr</strong>
      <span class="nostr-publish-subtitle">— online storage for sharable URLs</span>
      <nostr-status *ngIf="saving && shareEnabled" [progress$]="nostrStatus.publishProgress$"></nostr-status>
      <nz-switch class="nostr-share-switch" [ngModel]="shareEnabled" (ngModelChange)="onShareToggleChange($event)"></nz-switch>
    </div>
    <div class="nostr-visibility-row" *ngIf="shareEnabled">
      <button nz-button nzSize="small" nzShape="round" (click)="onVisibilityToggle()">
        <i nz-icon [nzType]="visibility === 'public' ? 'unlock' : 'lock'"></i>
        {{ visibility === 'public' ? 'Public' : 'Private' }}
      </button>
      <span class="nostr-visibility-hint">
        {{ visibility === 'public' ? 'Anyone with the link can view it.' : 'Only viewable with your Nostr key. Can manage your Nostr keys in the top right.' }}
      </span>
    </div>
  </div>

  <div class="share-url-section">
    <div class="share-url-row" *ngIf="previewUrl">
      <input nz-input readonly [value]="previewUrl" #urlInput (click)="urlInput.select()" />
      <button nz-button nz-tooltip nzTooltipTitle="Copy" (click)="urlInput.select(); copyShareUrl()">
        <i nz-icon nzType="copy"></i>
      </button>
    </div>
    <div class="share-url-note">
      <i nz-icon nzType="info-circle"></i> {{ urlNote }}
    </div>
  </div>

  <div *nzModalFooter>
    <button nz-button (click)="onNoClick()">{{'dialog.cancel' | translate}}</button>
    <button nz-button nzType="primary" (click)="onSaveAsNewClick()" *ngIf="!!data.id">{{'dialog.saveAsNew' | translate}}</button>
    <button nz-button nzType="primary" [nzLoading]="saving" (click)="onSaveClick()" cdkFocusInitial>{{ saveButtonLabel }}</button>
  </div>
</div>
